import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import { SpinnerWhite } from '../shared/Spinner'
import Questions from './Questions'
import PracticeInterviewResponses from './PracticeInterviewResponses'
import { useTranslation } from '../../hooks/useTranslation'
import AylaLoading from '../shared/AylaLoading'

const PracticeInterviewQuestions = () => {
  const { generatingInterview, showInterview, showResponses } =
    usePracticeInterviewing()

  return (
    <div className="flex w-full flex-row rounded-2xl bg-lily-blue px-4 py-8 text-primary md:m-8">
      {generatingInterview && <LoadingScreen />}
      {showInterview && <Questions />}
      {showResponses && <PracticeInterviewResponses />}
    </div>
  )
}

const LoadingScreen = () => {
  const { t } = useTranslation('PracticeInterviewQuestions')
  return (
    <div className="flex w-full flex-col">
      <h2 className="mb-4">{t('title')}</h2>
      <p className="mb-8">{t('description')}</p>
      <div className="h-full w-full">
        <div className="flex items-center justify-center">
          <AylaLoading />
        </div>
      </div>
      <div className="w-full text-right">
        <Button>
          {t('generating')}{' '}
          <SpinnerWhite show={true} className="mt-2 h-8 w-8 pl-2" />
        </Button>
      </div>
    </div>
  )
}

export default PracticeInterviewQuestions
